module.exports = "<div *ngIf=\"displayError\" >\n  <span class=\"sr-only\">(error)</span>\n  <div class=\"error-msg\">\n    {{ displayError }}\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// /Users/vishitamandloi/Documents/vishitaProjects/waz/angular/adminportal/waz-admin-panel/src/app/shared/field-error-display/field-error-display.component.html
// module id = ../../../../../src/app/shared/field-error-display/field-error-display.component.html
// module chunks = main